"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var components_1 = require("@athena-portal/components");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var ClaimsTree_1 = require("./ClaimsTree");
var ConvictionsTree_1 = require("./ConvictionsTree");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var Page_1 = require("../Page");
var operators_1 = require("rxjs/operators");
var LookupValue_1 = require("../../helpers/LookupValue");
var React = require("react");
var moment = require("moment");
var FieldDisplay_1 = require("../../components/FieldDisplay");
var LookupFieldDisplay_1 = require("../../components/LookupFieldDisplay");
var Tree_1 = require("../../components/Tree");
var InsuredPersonTree = /** @class */ (function (_super) {
    __extends(InsuredPersonTree, _super);
    function InsuredPersonTree(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates;
        _this.readonlyRole = !_this.supportPortalTemplates.userHasRole(["Administrator", "Claims_Handler", "Fraud", "CSR_Lead", "CSR", "Read_Only"]);
        _this.restrictedAccessRole = _this.supportPortalTemplates.userHasRole(["Administrator", "Claims_Handler", "Fraud", "CSR_Lead", "Support"]);
        _this.state = {
            fraudBlockList: undefined
        };
        return _this;
    }
    InsuredPersonTree.prototype.componentDidMount = function () {
        var _this = this;
        if (services_1.productHelper.isMotor(this.props.interaction)) {
            this.context.loadingQueue.increment(function () {
                _this.supportPortalService
                    .getFraudBlockList(_this.props.interactionPerson.licence.number)
                    .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                    .subscribe(function (fraudBlockList) {
                    _this.setState({ fraudBlockList: fraudBlockList });
                });
            });
        }
    };
    InsuredPersonTree.prototype.render = function () {
        var _this = this;
        var address = this.getAddress();
        var occupationLookup = services_1.productHelper.isMotor(this.props.interaction) ? "occupation" : "wolfOccupation";
        return ((0, jsx_runtime_1.jsxs)(Tree_1.Tree, { label: "".concat(this.props.treeContentString), children: [(0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "First name", value: this.props.person.firstName }), (0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Last name", value: this.props.person.lastName }), (0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Date of birth", value: this.getHidden() || this.supportPortalTemplates.convertDate(this.props.person.dateOfBirth, "DD/MM/YYYY") }), address && (0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Address", value: this.getAddress() }), this.props.person.email && (0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Email address", value: this.props.person.email }), this.props.person.phoneMobile && (0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Mobile number", value: this.props.person.phoneMobile }), this.props.interactionPerson && ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [services_1.productHelper.isMotor(this.props.interaction) || services_1.productHelper.isWolfMotor(this.props.interaction) &&
                            this.renderMotorSpecificFields(), (0, jsx_runtime_1.jsx)(LookupFieldDisplay_1.LookupFieldDisplay, { label: "Employment status", type: "employmentStatus", id: this.props.interactionPerson.employmentStatus }), !services_1.productHelper.isRenters(this.props.interaction) &&
                            (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(LookupFieldDisplay_1.LookupFieldDisplay, { label: "Occupation", type: occupationLookup, id: this.props.interactionPerson.occupation }), (0, jsx_runtime_1.jsx)(LookupFieldDisplay_1.LookupFieldDisplay, { label: "Marital status", type: "maritalStatus", id: this.props.interactionPerson.maritalStatus })] }), (0, jsx_runtime_1.jsx)(ClaimsTree_1.default, { claims: this.props.interactionPerson.claims }), (!this.props.interactionPerson.dlnLookupData || (this.props.interactionPerson.dlnLookupData.dlnLookupCallSucess && this.restrictedAccessRole) || !this.props.interactionPerson.dlnLookupData.dlnLookupCallSucess) && this.getConvictions(), (services_1.productHelper.isMotor(this.props.interaction) && this.supportPortalTemplates.userHasRole(["Administrator", "Fraud"])) &&
                            (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Blocked", value: this.state.fraudBlockList ? "true" : "false" }), !!this.state.fraudBlockList &&
                                        (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { className: "muli-bold-16", children: "Block reason:" }), ' ', this.state.fraudBlockList.cancellationCode && (0, jsx_runtime_1.jsx)(LookupValue_1.LookupValue, { type: "cancellationReasons", id: this.state.fraudBlockList.cancellationCode.toString() })] }), (0, jsx_runtime_1.jsx)("a", { className: "d-block text-primary on-hover-underline", onClick: function () { return _this.deleteFraudBlock(); }, children: "Remove block" })] })] })] }))] }, this.props.person.id));
    };
    InsuredPersonTree.prototype.renderMotorSpecificFields = function () {
        var _a;
        var licenceNumber = this.getHidden() || this.props.interactionPerson.licence.number ? this.props.interactionPerson.licence.number : "not declared";
        var startDate = this.props.interactionPerson.licence.passDate ? this.supportPortalTemplates.convertDate(this.props.interactionPerson.licence.passDate, "DD/MM/YYYY") : "not declared";
        var expirationDate = "not declared";
        var expirationClass = "";
        if (this.props.interactionPerson.licence.expirationDate) {
            expirationDate = this.supportPortalTemplates.convertDate(this.props.interactionPerson.licence.expirationDate, "DD/MM/YYYY");
            expirationClass = new Date(this.props.interactionPerson.licence.expirationDate) <= new Date() ? "text-danger" : "";
        }
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [((_a = this.props.interactionPerson.dlnLookupData) === null || _a === void 0 ? void 0 : _a.dlnLookupCallSucess) &&
                    (0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Driving licence number", value: licenceNumber }), (!this.props.interactionPerson.dlnLookupData || (this.props.interactionPerson.dlnLookupData.dlnLookupCallSucess && this.restrictedAccessRole) || !this.props.interactionPerson.dlnLookupData.dlnLookupCallSucess) &&
                    (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Driving licence start date", value: startDate }), (0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Driving licence expiration date", value: expirationDate, customStyle: expirationClass }), (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { className: "muli-bold-16", children: "Driving licence:" }), ' ', this.props.interactionPerson.licence.type &&
                                            (0, jsx_runtime_1.jsx)(LookupValue_1.LookupValue, { type: "drivingLicenceTypes", id: this.props.interactionPerson.licence.type.toString() }), this.getYearsLicenceHeld()] }) })] })] }));
    };
    InsuredPersonTree.prototype.getAddress = function () {
        if (this.readonlyRole) {
            return this.getHidden() + this.props.address.substring(this.props.address.indexOf(','));
        }
        return this.props.address;
    };
    InsuredPersonTree.prototype.getConvictions = function () {
        if (!this.readonlyRole && this.props.interactionPerson.convictions && this.props.interactionPerson.convictions.length > 0) {
            return (0, jsx_runtime_1.jsx)(ConvictionsTree_1.default, { convictions: this.props.interactionPerson.convictions, product: this.props.interaction.product });
        }
        var value = this.getHidden() || "none";
        return (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { className: "muli-bold-16", children: "Convictions:" }), " ", value] }) });
    };
    InsuredPersonTree.prototype.getHidden = function () {
        if (this.readonlyRole) {
            return '[hidden]';
        }
        return '';
    };
    InsuredPersonTree.prototype.deleteFraudBlock = function () {
        var _this = this;
        this.context.loadingQueue.increment(function () {
            _this.supportPortalService
                .deleteFraudBlockList(_this.state.fraudBlockList)
                .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                .subscribe(function () { return _this.setState({
                fraudBlockList: undefined
            }); });
        });
    };
    InsuredPersonTree.prototype.getYearsLicenceHeld = function () {
        if (services_1.productHelper.isMotor(this.props.interaction)) {
            return this.props.interactionPerson.licence.years ? ", " + this.props.interactionPerson.licence.years + " years" : "";
        }
        else if (services_1.productHelper.isWolfMotor(this.props.interaction) && this.props.interactionPerson.licence.passDate !== undefined && this.props.interactionPerson.licence.passDate != null) {
            var passDate = moment(this.props.interactionPerson.licence.passDate);
            var years = moment.duration(moment().diff(passDate)).years();
            return ", " + years + " years";
        }
        else {
            return ", " + this.getExperienceLabel(this.props.interactionPerson.drivingExperience);
        }
    };
    InsuredPersonTree.prototype.getExperienceLabel = function (value) {
        var _a;
        var experienceMap = {
            "1": "Less than 1 year",
            "2": "1-2 years",
            "3": "2-3 years",
            "4": "3-4 years",
            "5": "4-5 years",
            "6": "5-6 years",
            "7": "6-7 years",
            "8": "7-8 years",
            "9": "8 or more years",
        };
        return (_a = experienceMap[value]) !== null && _a !== void 0 ? _a : "";
    };
    InsuredPersonTree.contextType = Page_1.PageContext;
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], InsuredPersonTree.prototype, "supportPortalService", void 0);
    InsuredPersonTree = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], InsuredPersonTree);
    return InsuredPersonTree;
}(React.Component));
exports.default = InsuredPersonTree;
//# sourceMappingURL=InsuredPersonTree.js.map